/**
 * Sales Module Routes (custom extensions)
 *
 * Extends the auto-generated routes with custom routes
 * like dashboards that are not generated from entity DSL.
 */

import { lazy, Suspense } from 'react';
import { salesRoutes as generatedSalesRoutes } from './sales.generated';

const SalesOverviewDashboard = lazy(
  () => import('@/sales/dashboards/SalesOverviewDashboard.generated').then(m => ({ default: m.SalesOverviewDashboard }))
);

const SalesSettingsPage = lazy(
  () => import('@/sales/settings/SalesSettingsPage.generated').then(m => ({ default: m.SalesSettingsPage }))
);

export const salesRoutes = [
  ...generatedSalesRoutes,
  {
    path: '/sales/dashboard',
    element: (
      <Suspense fallback={null}>
        <SalesOverviewDashboard />
      </Suspense>
    ),
  },
  {
    path: '/sales/settings',
    element: (
      <Suspense fallback={null}>
        <SalesSettingsPage />
      </Suspense>
    ),
  },
];
